import styled from 'styled-components'

export const Main = styled.div`
	overflow-y: scroll;
	display: grid;
	grid-area: main;
	grid-template-rows: 1fr auto;
`
